import { createNodeDef } from "../../nodes.helpers";
import { rand } from "@ngneat/falso";

export const randNodeDef = createNodeDef({
  type: "rand",
  displayName: "Rand",
  description: "Select a random child node",
  acceptsChildren: true,
  initialData: () => ({}),
  generate: async ({ children }) => rand(await children.generateValues()),
});
